

// eslint-disable-next-line import/no-unresolved
const baseAddress = require('base/checkout/address');

/**
 * Populate the Billing Address Summary View
 * @param {string} parentSelector - the top level DOM selector for a unique address summary
 * @param {Object} address - the address data
 */
function populateAddressSummary(parentSelector, address) {
    $.each(address, (attr) => {
        let val = address[attr];
        if (attr === 'stateCode') {
            val = address.descriptionState;
        }
        $(`.${attr}`, parentSelector).text(val || '');
    });
}


/**
 * returns a formed <option /> element
 * @param {Object} shipping - the shipping object (shipment model)
 * @param {boolean} selected - current shipping is selected (for PLI)
 * @param {order} order - the Order model
 * @param {Object} [options] - options
 * @returns {Object} - the jQuery / DOMElement
 */
function optionValueForAddress(shipping, selected, order, options) {
    const safeOptions = options || {};
    const isBilling = safeOptions.type && safeOptions.type === 'billing';
    const className = safeOptions.className || '';
    let isSelected = selected;
    var sameBillingAsShippingAddressMsg = '';// PL CHANGES $('#billingAddressSelector').data('title-same-as-shipping') || '';
    let isNew = !shipping;
    if (typeof shipping === 'string') {
        return $(`<option class="${className}" disabled>${shipping}</option>`);
    }
    const safeShipping = shipping || {};
    let shippingAddress = safeShipping.shippingAddress || {};

    if (isBilling && isNew && !order.billing.matchingAddressId) {
        shippingAddress = order.billing.billingAddress.address || {};
        isNew = false;
        isSelected = true;
        safeShipping.UUID = 'manual-entry';
    }

    const uuid = safeShipping.UUID ? safeShipping.UUID : 'new';
    const optionEl = $(`<option class="${className}" />`);
    optionEl.val(uuid);

    let title;

    if (isNew) {
        title = order.resources.addNewAddress;
    } else {
        title = [];
        if (isBilling && !shippingAddress.ID) {
            optionEl.attr('data-option-same-shipping-billing', 'true');
            title.push(sameBillingAsShippingAddressMsg);
        }
        
        if (shippingAddress.firstName) {
            title.push(shippingAddress.firstName);
        }
        if (shippingAddress.lastName) {
            title.push(shippingAddress.lastName);
        }
        if (shippingAddress.address1) {
            title.push(shippingAddress.address1);
        }
        if (shippingAddress.address2) {
            title.push(shippingAddress.address2);
        }
        if (shippingAddress.city) {
            if (shippingAddress.state) {
                title.push(`${shippingAddress.city},`);
            } else {
                title.push(shippingAddress.city);
            }
        }
        if (shippingAddress.stateCode) {
            title.push(shippingAddress.descriptionState || '');
        }
        if (shippingAddress.postalCode) {
            title.push(shippingAddress.postalCode);
        }
        if (!isBilling && safeShipping.selectedShippingMethod) {
            title.push('-');
            title.push(safeShipping.selectedShippingMethod.displayName);
        }

        if (title.length > 2) {
            title = title.join(' ');
        } else {
            title = order.resources.newAddress;
        }
    }

    optionEl.text(title);

    const keyMap = {
        'data-first-name': 'firstName',
        'data-last-name': 'lastName',
        'data-address1': 'address1',
        'data-address2': 'address2',
        'data-city': 'city',
        'data-state-code': 'stateCode',
        'data-postal-code': 'postalCode',
        'data-country-code': 'countryCode',
        'data-phone': 'phone',
    };
    $.each(keyMap, (key) => {
        const mappedKey = keyMap[key];
        let mappedValue = shippingAddress[mappedKey];
        // In case of country code
        if (mappedValue && typeof mappedValue === 'object') {
            mappedValue = mappedValue.value;
        }

        optionEl.attr(key, mappedValue || '');
    });

    const giftObj = {
        'data-is-gift': 'isGift',
        'data-gift-message': 'giftMessage',
    };

    $.each(giftObj, (key) => {
        const mappedKey = giftObj[key];
        const mappedValue = safeShipping[mappedKey];
        optionEl.attr(key, mappedValue || '');
    });

    if (isSelected) {
        optionEl.attr('selected', true);
    }

    return optionEl;
}


module.exports = {
    methods: {
        populateAddressSummary: populateAddressSummary,
        optionValueForAddress: optionValueForAddress,
        getAddressFieldsFromUI: baseAddress.methods.getAddressFieldsFromUI,
    },

    showDetails: baseAddress.showDetails,

    addNewAddress: baseAddress.addNewAddress,
};
